<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="purchaseOrderModal"
        persistent
        max-width="530px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">Purchase Order {{ purchaseOrderData.theOrderID }}</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closePurchaseOrderModal(), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="successAlert"
              > Order purchased successfully </v-alert>
              <v-layout wrap>
                <v-flex
                  xs12
                  sm12
                  style="font-size: 1.7rem"
                > Please select payment method </v-flex>

                <v-flex
                  xs12
                  sm12
                >
                  <v-select
                    autocomplete
                    :items="banks"
                    v-model="purchaseOrderData.bank_id"
                    :error-messages="errors.collect('Bank')"
                    data-vv-name="Bank"
                    label="Bank"
                    v-validate="'required'"
                  ></v-select>
                </v-flex>

                <!-- <v-flex v-if="purchaseOrderData.country === 'Turkey'" xs12 sm12>
                  <v-text-field
                    label="Item Cost in TL*"
                    v-model="purchaseOrderData.item_cost_in_tl"
                    :error-messages="errors.collect('Item Cost in TL')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item Cost in TL"
                  ></v-text-field>
                </v-flex> -->

                <!-- <v-flex v-else xs12 sm12 md7>
                  <v-text-field
                    style="width: 70%"
                    label="Item Cost in USD*"
                    v-model="purchaseOrderData.item_cost_in_usd"
                    :error-messages="errors.collect('Item Cost in USD')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item Cost in USD"
                  ></v-text-field>
                </v-flex> -->

                <v-flex xs12>
                  <v-text-field
                    label="Order Number"
                    v-model="purchaseOrderData.barcode"
                    :error-messages="errors.collect('Order Number')"
                    data-vv-name="Order Number"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    label="Actual Price"
                    v-model.number="purchaseOrderData.actual_price"
                    type="number"
                    :step="0.01"
                    :rules="[v => !!v || 'Actual Price is required', v => /^\d+(\.\d+)?$/.test(v) || 'Must be a valid number']"
                    v-validate="'required|decimal:2'"
                    :data-vv-name="'Actual Price'"
                    :error-messages="errors.collect('Actual Price')"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    label="Warehouse Date"
                    v-model="purchaseOrderData.warehouse_date"
                    type="date"
                    :error-messages="errors.collect('Warehouse Date')"
                    data-vv-name="Warehouse Date"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    label="From Date"
                    v-model="purchaseOrderData.from_date"
                    type="date"
                    :error-messages="errors.collect('From Date')"
                    data-vv-name="From Date"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    label="To Date"
                    v-model="purchaseOrderData.to_date"
                    type="date"
                    :error-messages="errors.collect('To Date')"
                    data-vv-name="To Date"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    label="Note"
                    v-model="purchaseOrderData.purchase_note"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height: auto"
                @click="closePurchaseOrderModal(), $validator.reset()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                style="height: auto; margin-right: 4%"
                outline
                color="success"
              >Purchase</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'purchaseOrderModal',
    'closePurchaseOrderModal',
    'checkAlert',
    'purchaseOrderData',
    'purchaseOrder',
    'purchaseAll',
    'successAlert',
    'banks'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.purchaseOrderData.ids && this.purchaseOrderData.ids.length > 0) {
            this.purchaseAll()
          } else {
            this.purchaseOrder()
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/purchaseOrder.vue